import images from './TournamentCharacterImages';
import flusteredImages from './TournamentFlusteredImages';
import victoryImages from './TournamentVictoryImages';
import catalog from '../config/tournamentCharacters.json';
export function normalizeCharacterId(value) {
  let raw = String(value || '');
  try { raw = decodeURIComponent(raw); } catch {}
  raw = raw.replace(/^(monster\.|player\.|monsters\/|players\/)/, '').split(/[\\/]/).pop().replace(/\.(png|webp|jpe?g)$/i, '');
  return catalog.aliases[raw] || raw;
}
export const PLAYER_IMAGE_OPTIONS = catalog.characters.map((c) => ({ ...c, label: c.name, src: images[c.id] }));
export const playerImageMap = { ...images };
for (const [alias, id] of Object.entries(catalog.aliases)) playerImageMap[alias] = images[id];
export const monsterImageMap = Object.fromEntries(Object.entries(playerImageMap).map(([id, src]) => [id, { normal: src, depressed: src }]));
export function getParticipantImage(participant, mood = 'normal') {
  if (!participant) return null;
  const id = normalizeCharacterId(participant.characterId || participant.imageId);
  if (mood === 'victory' && victoryImages[id]) return victoryImages[id];
  if ((mood === 'flustered' || mood === 'depressed') && flusteredImages[id]) return flusteredImages[id];
  return images[id] || null;
}
